import { CreateChartOptions } from '~/types/create.types';
import { TimeSeriesItem, TsDataPoint } from '~/types/timeseries.types';
import { RangeHorizon } from '~/ui/components/resample-selector/ResampleSelector.types';

import { chartStore } from '../chart-store/chartStore';
import { listenerModel } from '../listeners/listeners';
import { reDraw } from '../recalculate/recalculate';
import { timescaleModel } from '../time-scale/timeScale';

export const setup = (
  canvasElement: HTMLCanvasElement,
  options: CreateChartOptions,
  context: CanvasRenderingContext2D
) => {
  const store = chartStore.getState();
  const timeScale = timescaleModel(store.base);
  const listeners = listenerModel(canvasElement, timeScale);

  const initialiseData = (
    horizon: RangeHorizon,
    data: TsDataPoint[],
    timeseries: TimeSeriesItem[]
  ) => {
    const updatedBase = store.initialise({
      horizon,
      data,
      timeseries,
      options,
      context,
    });
    reDraw(updatedBase);
  };

  return {
    setListeners: listeners.setListeners,
    initialiseData,
  };
};
